import { useEffect } from 'react';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { EducaLIECContent } from '@/components/sections/educaliec';
import { useYouTubePlaylist } from '@/hooks/useYouTubePlaylist';

export function EducaLIECPage() {
  const { videos, loading, error, refetch } = useYouTubePlaylist();

  // Scroll to top when navigating to this page
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1 pt-20 lg:pt-24">
        <EducaLIECContent videos={videos} loading={loading} error={error} onRetry={refetch} />
      </main>
      <Footer />
    </div>
  );
}
